import { withStyles } from '@material-ui/core/styles'
import DialogTitle from '@material-ui/core/DialogTitle'

const CustomDialogTitle = withStyles(theme => ({
  root: {
    padding: 18,
    backgroundColor: theme.palette.secondary.main,
    color: 'white',
    fontSize: 19,
    textAlign: 'center'
  }
}))(DialogTitle)

export default CustomDialogTitle
